export type CurrencyString = string | Currency;

export enum Currency {
  AUD = 'AUD',
  USD = 'USD',
  NZD = 'NZD',
  GBP = 'GBP',
  CAD = 'CAD',
  EUR = 'EUR',
  HKD = 'HKD',
  ILS = 'ILS',
  MXN = 'MXN',
  INR = 'INR',
  SGD = 'SGD',
  MYR = 'MYR',
  BRL = 'BRL',
}

export const CurrencySymbol: Record<Currency, string> = {
  [Currency.AUD]: 'AU$',
  [Currency.GBP]: '£',
  [Currency.NZD]: '$',
  [Currency.USD]: '$',
  [Currency.CAD]: 'C$',
  [Currency.EUR]: '€',
  [Currency.HKD]: 'HK$',
  [Currency.ILS]: '₪',
  [Currency.MXN]: '$',
  [Currency.INR]: '₹',
  [Currency.SGD]: 'S$',
  [Currency.MYR]: 'RM',
  [Currency.BRL]: 'R$',
};
